import { createReducer } from 'redux-act';
import { StateStatus } from '@alycecom/utils';

import { MessageType } from '../../../../store/types/Message.types';

import { fetchCodeData } from './codeData.actions';
import { ICodeData } from './codeData.types';

export interface ICodeDataState {
  status: StateStatus;
  data: ICodeData;
}

export const initialState: ICodeDataState = {
  status: StateStatus.Idle,
  data: {
    hashId: '',
    countryId: null,
    message: {
      type: MessageType.text,
      content: '',
      header: '',
    },
    product: {
      id: 0,
      image: '',
      name: '',
      provider: '',
      options: '',
      hasOptions: false,
      isAddressRequired: false,
      isDonation: false,
      isTangoCard: false,
      typeId: 0,
      countryId: 0,
      denomination_currency_id: 0,
      brand: { name: '' },
      hasExternalFulfillment: false,
      hasRangeDenomination: false,
    },
    customizations: {
      redirectUrl: null,
      redirectHeader: null,
      redirectButton: null,
      redirectConfirm: false,
      redirectMessage: null,
      hidePrefilledReasons: false,
      hideHeaders: false,
      messageImageUrl: null,
      mobileMessageImageUrl: null,
    },
  },
};

export const codeData = createReducer<ICodeDataState>({}, initialState);

codeData
  .on(fetchCodeData.pending, state => ({
    ...state,
    status: StateStatus.Pending,
  }))
  .on(fetchCodeData.fulfilled, (state, payload) => ({
    ...state,
    status: StateStatus.Fulfilled,
    data: payload,
  }))
  .on(fetchCodeData.rejected, state => ({
    ...state,
    status: StateStatus.Rejected,
  }));
